import { Component } from 'react';
import styled from 'styled-components';
import { IBaseLayoutProps } from '../Layout/IBaseLayoutProps';
import { BaseLayout } from '../Layout/BaseLayout';

export type GridBehaviourType = 'auto-fit' | 'auto-fill';

const GridElement = styled.div<IProps>`
  display: grid;
  grid-template-columns: repeat(
    ${(props: any) => props.gridBehaviour || 'auto-fill'},
    minmax(${(props: any) => props.childWidth || 400}px, 1fr)
  );
  grid-gap: ${props => props.gridGap + 'px'};
  margin-right: ${props => (props.margin === false ? '0px' : '50px')};
  margin-bottom: ${props => (props.margin === false ? '0px' : '50px')};
` as any;

interface IProps extends IBaseLayoutProps {
  /** Width of child "cells" in pixels.  Defaults to 400px. */
  childWidth?: number;
  /** Sets the gap between each column */
  gridGap?: number;
  /** Whether it should be auto-fill or auto-fit, Defaults to auto-fill */
  gridBehaviour?: GridBehaviourType;
  margin?: boolean;
}

export class GridLayout extends Component<IProps> {
  public render() {
    return (
      <BaseLayout {...this.props} data-testid="GridLayout">
        <GridElement
          gridGap={this.props.gridGap ? this.props.gridGap : '50'}
          childWidth={this.props.childWidth}
          gridBehaviour={this.props.gridBehaviour}
          margin={this.props.margin}
        >
          {this.props.children}
        </GridElement>
      </BaseLayout>
    );
  }
}
